import { useSelector, useDispatch } from "react-redux";
import {
  setCotacoes as sc,
  setItemSelecionado as sis,
  setItensCotacao as sic,
  setCotacaoSelecionada as scs,
  setCheckedItemCotacao as scki,
} from "../store/slices/cotacaoSlice";

export const useCotacao = () => {
  const { cotacoes, itensCotacao, cotacaoSelecionada, itemSelecionado } =
    useSelector((state) => state.cotacao);
  const dispatch = useDispatch();

  const setCotacoes = (cotacoes) => {
    dispatch(sc(cotacoes));
  };

  const setCotacaoSelecionada = (cotacao) => {
    dispatch(scs(cotacao));
  };

  const setItensCotacao = (itens) => {
    dispatch(sic(itens));
  };

  const setItemSelecionado = (item) => {
    dispatch(sis(item));
  };

  const setCheckedItemCotacao = ({ itemId, add = false, remove = false }) => {
    dispatch(scki({ itemId, add, remove }));
  };

  return {
    cotacoes,
    itensCotacao,
    itemSelecionado,
    cotacaoSelecionada,
    setCotacoes,
    setItensCotacao,
    setItemSelecionado,
    setCotacaoSelecionada,
    setCheckedItemCotacao,
  };
};
